"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@coreui/react");
const react_table_1 = require("@tanstack/react-table");
const react_2 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const portal_api_1 = require("portal-api");
const utils_1 = require("utils");
const slice_1 = require("../locations/slice");
const utils_2 = require("../utils");
const CoreUITable_1 = __importDefault(require("./CoreUITable"));
const selectLocations = (state) => state.root.internalPortal.locations;
function SlideIn() {
    // Hooks
    const history = (0, react_router_dom_1.useHistory)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { showDrawer } = (0, react_redux_1.useSelector)(selectLocations);
    // State
    const [visible, setVisible] = (0, react_2.useState)(showDrawer);
    const [skipEnrollments, setSkipEnrollments] = (0, react_2.useState)(true);
    // Query
    const { data: globalConfig } = (0, portal_api_1.useGetInternalPortalV1FeatureFlagsGlobalQuery)();
    const globalConfigFix = globalConfig;
    // Query
    const { data: users } = (0, portal_api_1.useGetInternalPortalV1UsersQuery)();
    // Query
    const { data: enrollments } = (0, portal_api_1.useGetInternalPortalV1EnrollmentsQuery)({}, { skip: skipEnrollments });
    // Permissions
    const permissions = (0, utils_2.getPermissions)(users);
    // Table Data + Columns
    const enrollmentsArr = enrollments;
    const enrollmentsData = enrollmentsArr?.map((itm) => {
        return {
            storeNum: itm.storeNumber,
            createdAt: (0, utils_1.formatISODateStringAsUSMonthDayYear)(itm.createdAt),
            locationName: itm.locationName,
            merchantApplicationId: itm.merchantApplicationId,
            status: itm.status,
            locationId: itm.locationId,
        };
    });
    // Table Columns
    const columnHelper = (0, react_table_1.createColumnHelper)();
    const columns = [
        columnHelper.accessor('storeNum', {
            header: 'Store #',
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor('status', {
            header: 'Status',
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor('locationName', {
            header: 'Location',
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor('createdAt', {
            header: 'Date',
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor('merchantApplicationId', {
            header: 'AppId',
            cell: (info) => info.getValue(),
        }),
    ];
    const handleClickRow = (0, react_2.useCallback)((id) => {
        dispatch((0, slice_1.setShowDrawer)(!visible));
        const rowData = enrollmentsData
            .filter((itm) => {
            return String(itm.merchantApplicationId) === String(id);
        })
            .at(0);
        history.push({
            pathname: (0, config_1.makePath)(config_1.PATH.INTERNAL_PORTAL, config_1.PATH.LOCATIONS, '/', rowData?.locationId),
            search: `?app_id=${id}&tab=enrollment`,
        });
    }, [enrollmentsData]);
    (0, react_2.useEffect)(() => {
        if (permissions.hasLocationEnrollmentRead() &&
            globalConfigFix?.featureFlags.mfeEnrollments) {
            setSkipEnrollments(false);
        }
    }, [permissions.hasLocationEnrollmentRead(), globalConfigFix]);
    (0, react_2.useEffect)(() => {
        if (enrollments && permissions.hasLocationEnrollmentRead()) {
            dispatch((0, slice_1.setEnrollments)(enrollments));
        }
    }, [enrollments, permissions.hasLocationEnrollmentRead()]);
    (0, react_2.useEffect)(() => {
        setVisible(showDrawer);
    }, [showDrawer]);
    (0, react_2.useEffect)(() => {
        dispatch((0, slice_1.setShowDrawer)(visible));
    }, [visible]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(react_1.COffcanvas, { className: "offcanvas-sidebar", placement: "start", backdrop: false, scroll: false, visible: visible, onHide: () => setVisible(false), children: [(0, jsx_runtime_1.jsx)(react_1.COffcanvasHeader, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex space-between w100", children: [(0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_1.COffcanvasTitle, { children: "Enrollments" }) }), (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_1.CCloseButton, { dark: true, className: "text-reset", onClick: () => setVisible(false) }) })] }) }), (0, jsx_runtime_1.jsx)(react_1.COffcanvasBody, { children: (0, jsx_runtime_1.jsx)(CoreUITable_1.default, { pageSize: 50, borderless: true, bordered: true, striped: false, small: false, data: enrollmentsData ?? [], columns: columns, clickRow: (row) => handleClickRow(row), rowId: "merchantApplicationId" }) })] }) }));
}
exports.default = SlideIn;
